import { RootState } from 'slices';

export const layoutSelector = {
  getLayout: (state: RootState) => state.Layout,
};
